import styled from 'styled-components';

import { gridSizes, media, weights } from 'utils/style';
import Form from 'refactored/features/soForm/steps/card/creditCard/Form/container';

export default styled(Form)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: visible;

  ${media.lessThan('medium')`
overflow-y: auto;
`};

  h1 {
    color: var(--grey900);
    font-size: 32px;
    margin: 0;
    font-weight: ${weights('medium')};
    line-height: 38px;
  }

  h2,
  .feedback-message {
    color: var(--grey700);
    font-size: ${gridSizes('M')};
    margin: 0;
    margin-top: ${gridSizes('S')};
    font-weight: ${weights('regular')};
    line-height: 19px;
  }

  p {
    color: var(--grey700);
  }

  .feedback-message {
    margin-top: 0;
    margin-bottom: ${gridSizes('M')};
  }

  .card-container {
    border-radius: ${gridSizes('S')};
    border: solid 1px var(--grey500);
    padding: ${gridSizes('L')};
    margin: ${gridSizes('L')} 0;

    .block {
      display: flex;
      & > div {
        &:first-child {
          margin-right: 12px;
        }

        width: 30% !important;
        ${media.lessThan('small')`
              width: 50% !important;
              margin-right: 0px;
          `};
      }
    }
  }

  .summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 32px;

    button {
      min-width: 30%;
      text-transform: uppercase;
    }
  }

  .error {
    color: var(--red-cherry-text);
  }

  .vat-value {
    font-size: ${gridSizes('M')};
    color: var(--grey900);
    font-weight: ${weights('regular')};
    margin: 0;
    text-align: right;

    .price {
      text-align: left;
      font-weight: ${weights('medium')};
      color: var(--grey900);
      font-size: 3.2rem;
    }

    ${media.lessThan('medium')`
    text-align: left;
  `};
  }
`;
